export enum SymptomsArticleTypes {
  GENERAL_PRECAUTION = 'general_precautions',
  RARE_SIDE_EFFECT = 'rse',
  OCCASIONAL_SIDE_EFFECT = 'ose',
  LONG_TERM_SIDE_EFFECT = 'ltse',
  IMMUNO = 'immuno',
}
